import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useTemplateSettings } from "../../../../api/templateSettingsApi"
import { encodeProductGroup, NO_PRODUCT_GROUP } from "./articleFilter"

interface ProductGroupSelectProps {
  options: { value: string; count?: number }[]
  /** "" = all groups, NO_PRODUCT_GROUP = articles without one. */
  value: string
  onChange: (value: string) => void
  /** Offer the "without group" choice. */
  includeNone: boolean
}

/** Product-group dropdown, labelled with the org's own name for the field
 * (inquiry template settings), falling back to the master-data label. */
export function ProductGroupSelect({
  options,
  value,
  onChange,
  includeNone,
}: ProductGroupSelectProps) {
  const { translate } = useTranslation()
  const { data: templateSettings } = useTemplateSettings()
  const label =
    templateSettings?.productGroupLabel ||
    translate("MC_MD_FIELD_PRODUCT_GROUP")

  return (
    <select
      aria-label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-8 max-w-48 shrink-0 rounded-md border border-grey4 bg-transparent px-2 text-xs text-white focus-visible:border-yellow1 focus-visible:outline-hidden"
    >
      <option value="">
        {translate("MC_INQ_DRAFT_ART_GROUP_ALL", { label })}
      </option>
      {includeNone && (
        <option value={NO_PRODUCT_GROUP}>
          {translate("MC_MD_FILTER_NO_PRODUCT_GROUP_OPTION", { label })}
        </option>
      )}
      {options.map((o) => (
        <option key={o.value} value={encodeProductGroup(o.value)}>
          {o.count === undefined ? o.value : `${o.value} (${o.count})`}
        </option>
      ))}
    </select>
  )
}
